import { createStore } from 'vuex';

interface State {
    loading: boolean
    route: string
    baseRUrl: string
    openModal: number
}

const store = createStore<State>({
    state: {
        loading: false,
        route: '/home',
        baseRUrl: 'localhost:8000/',
        openModal: -1
    },
    mutations: {
        setLoading(state, loading: boolean) {
            state.loading = loading;
        },
        setRoute(state, route: string) {
            state.route = route
        },
        setOpenModal(state, index: number) {
            state.openModal = index
        },
    },
    actions: {
        login({ commit }, token: string) {
            commit
            sessionStorage.setItem("token", token)
        },
        logout() {
            sessionStorage.removeItem("token")
        },
        setLoading({ commit }, loading: boolean) {
            commit('setLoading', loading)
        },
        navigate({ commit }, route: string) {
            commit('setRoute', route)
        },
        modal({ commit }, index: number) {
            commit('setOpenModal', index)
        }
    },
    getters: {
        isLoggedIn: () => sessionStorage.getItem("token") != null,
        loading: state => state.loading,
        route: state => state.route,
        baseRUrl: state => state.baseRUrl,
        openModal: state => state.openModal,
    }
});

export default store;
